import { useState, useContext } from 'react';
import { useIsAuthenticated } from "@azure/msal-react";
import { useNavigate, useLocation } from 'react-router-dom';
import { AppContext } from "AppContext";

import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { SxProps } from '@mui/system/styleFunctionSx/styleFunctionSx';
import AssessmentIcon from '@mui/icons-material/Assessment';

import { PowerBiReport } from 'models/models';

import DataLoading from './DataLoading';

const LeftNav = () => {
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();
  const location = useLocation();
  const { embeddingData } = useContext(AppContext);

  const isNotDeleteMyAccountPage: boolean = (location.pathname.toLowerCase().indexOf("deletemyaccount") === -1)

  const expandedLeftNavWidth = 240;
  const colapsedLeftNavWidth = 48;
  const [leftNavWidth, setLeftNavWidth] = useState(colapsedLeftNavWidth);
  const [leftNavExpanded, setLeftNavExpanded] = useState(false);

  const leftNavTopBoxProps: SxProps = { width: 1, color: "#000000", backgroundColor: "rgb(244, 252, 255)", mt: "0px" };

  const leftNavOuterBoxProps: SxProps = { width: 1, color: "#000000", backgroundColor: "rgb(244, 252, 255)", display: "flex"};

  const leftNavInnerBoxLeftProps: SxProps = {
    width: "48px",
    minWidth: "48px",
    textAlign: "center",
    p: 0,
    pt: "0px",
    color: "#444444"
  };

  const avatarProps: SxProps = { width: "22px", height: "22px", m: 0, mt: "8px", mb: "8px" };

  const leftNavInnerBoxRightProps: SxProps = {
    py: 0,
    pl: "0px",
    width: leftNavExpanded ? 1 : 0, color: "black"
  };

  const leftNavHeaderProps: SxProps = {
    fontSize: "16px", width: 1, fontWeight:"600", color: "#444444", pl: 0, mt: "5px", mb: "10px", pt: "2px", fontFamily:"inter,sans-serif !important", letterSpacing:"0"
  };

  const leftNavListProps: SxProps = {
    m: 0, p: 0, pb: "8px", width: 1
  };

  const toggleLeftNavWidth = () => {
    if (leftNavExpanded) {
      setLeftNavExpanded(false);
      setLeftNavWidth(colapsedLeftNavWidth);
      window.removeEventListener('click', collapseLeftNavOnOutsideClick);
    }
    else {
      setLeftNavExpanded(true);
      setLeftNavWidth(expandedLeftNavWidth);
      window.addEventListener('click', collapseLeftNavOnOutsideClick);
    }
  };

  function collapseLeftNavOnOutsideClick(event: MouseEvent) {
    let leftNavEle = document.getElementById("leftNavZone");
    if (!leftNavEle?.contains(event.target as HTMLButtonElement)) { 
      setLeftNavExpanded(false);
      setLeftNavWidth(colapsedLeftNavWidth);
      window.removeEventListener('click', collapseLeftNavOnOutsideClick);
    }
  }

  return (
    <Drawer variant='permanent' anchor='left'
      sx={{
        width: leftNavWidth, zIndex: 1, pt: "84px", pb: 3, overflow: "hidden",
        display: (isAuthenticated && !embeddingData.workspaceArtifactsLoading && isNotDeleteMyAccountPage) ? "flex" : "none",
        position: "absolute",
      }}
      id="leftNavZone"
      PaperProps={{ sx: { width: leftNavWidth, backgroundColor: "rgb(244, 252, 255, 1)", borderRight: "1px solid #9EACB4", overflow: "hidden", top:"52px" } }}  >
      <Box sx={{...leftNavTopBoxProps, ...(navigator.onLine ? {} : { marginTop: "95px" })}} >
        <Box sx={leftNavOuterBoxProps}>
          <Box sx={leftNavInnerBoxLeftProps} onClick={toggleLeftNavWidth} style={{ cursor: 'pointer', height:"44px", borderBottom:"1px solid #9EACB4", paddingTop:"2px"}}>
            <AssessmentIcon sx={avatarProps} style={{ cursor: 'pointer'}}/>
          </Box>
          {leftNavExpanded &&
            <Box sx={leftNavInnerBoxRightProps}>
              <Typography sx={leftNavHeaderProps} onClick={toggleLeftNavWidth} style={{cursor: 'pointer', padding:"4px 0 10px 6px", borderBottom:"1px solid #9EACB4"}} >Available Reports</Typography>
              
              {embeddingData.workspaceArtifactsLoading && <DataLoading />}
              {!embeddingData.workspaceArtifactsLoading && (
                <List disablePadding dense sx={leftNavListProps}>
                  {embeddingData.reports?.map((report: PowerBiReport) => (
                    <ListItem button key={report.id}
                      sx={{
                        py: "4px", pl: "6px", width: 1,
                        mb:"4px",
                        minHeight:"50px",
                        fontWeight: "bold",
                        fontFamily:"inter,sans-serif !important",
                        fontSize: "14px",
                        color: "#444444",
                        backgroundColor: (document.URL.includes(report.id)) ? "#FFFFFF !important" : "rgb(244, 252, 255)",
                        boxShadow: (document.URL.includes(report.id)) ? "rgba(0, 0, 0, 0.08) 0px 3px 4px 0px" : "none",
                        borderRight:"none",
                        borderRadius:"2px",
                        borderLeft: (document.URL.includes(report.id)) ? "4px solid rgb(0, 147, 200)" : "none"
                      }}
                      onClick={() => {
                        navigate("/reports/" + report.id);
                        toggleLeftNavWidth();
                      }} >{report.name}</ListItem>

                  ))}
                </List>
              )}
            </Box>
          }
        </Box>

      </Box>
    </Drawer >
  )
}

export default LeftNav